// hooks/useUnifiedColorMode.ts
import { useColorScheme } from "@mui/material/styles";

export function useUnifiedColorMode() {
    const { mode, setMode } = useColorScheme();

    // Provide a 2-state toggle; easy to extend for 3-state with "system".
    const toggle = () => {
        if (!mode) return;
        setMode(mode === "dark" ? "light" : "dark");
    };

    return { mode, setMode, toggle };
}
